(function () {
  'use strict';

  function scrollToConfiguration() {
    const target = document.querySelector('[data-config-step="variant"], variant-picker, .variant-picker, .gpo-container');
    if (!target) return;
    const targetTop = window.scrollY + target.getBoundingClientRect().top - 88;
    window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
  }

  function initConfigurationTriggers() {
    document.querySelectorAll('[data-configure-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        scrollToConfiguration();
      });
    });

    document.addEventListener('click', function (event) {
      const trigger = event.target && event.target.closest('[data-configure-trigger]');
      if (!trigger) return;
      event.preventDefault();
      scrollToConfiguration();
    }, true);
  }

  function initDeliveryCard() {
    const card = document.querySelector('.la-pdp-delivery-card');
    if (!card) return;
    const stockText = card.querySelector('[data-delivery-stock-text]');
    const json = card.querySelector('.la-pdp-variants-availability');
    if (!stockText || !json) return;

    let variantsMap = {};
    try {
      JSON.parse(json.textContent || '[]').forEach(function (variant) {
        variantsMap[String(variant.id)] = !!variant.available;
      });
    } catch (error) {
      variantsMap = {};
    }

    function selectedVariantId() {
      const hiddenInput = document.querySelector('input[name="id"]');
      if (hiddenInput && hiddenInput.value) return String(hiddenInput.value);
      const checked = document.querySelector('.variant-picker input[data-variant-id]:checked');
      return checked ? String(checked.getAttribute('data-variant-id')) : '';
    }

    function sync() {
      const variantId = selectedVariantId();
      const available = variantId && Object.prototype.hasOwnProperty.call(variantsMap, variantId)
        ? variantsMap[variantId]
        : true;
      card.dataset.available = available ? 'true' : 'false';
      stockText.textContent = available ? card.dataset.stockText : card.dataset.oosText;
    }

    document.addEventListener('change', function (event) {
      const target = event.target;
      if (!target) return;
      if (target.matches('input[name="id"], .variant-picker input[type="radio"], .variant-picker input[type="checkbox"]')) {
        sync();
      }
    });

    sync();
  }

  function initCompareNote() {
    const note = document.querySelector('.la-pdp-compare-note');
    const pricingJson = document.querySelector('.la-pdp-variants-pricing');
    if (!note || !pricingJson) return;

    const base = note.querySelector('.la-pdp-compare-note__base');
    const hint = note.querySelector('.la-pdp-compare-note__hint');
    if (!base || !hint) return;

    let variantsMap = {};
    try {
      JSON.parse(pricingJson.textContent || '[]').forEach(function (variant) {
        variantsMap[String(variant.id)] = {
          price: Number(variant.price) || 0,
          compareAtPrice: Number(variant.compare_at_price) || 0
        };
      });
    } catch (error) {
      variantsMap = {};
    }

    function selectedVariantId() {
      const hiddenInput = document.querySelector('input[name="id"]');
      if (hiddenInput && hiddenInput.value) return String(hiddenInput.value);
      const checked = document.querySelector('.variant-picker input[data-variant-id]:checked');
      return checked ? String(checked.getAttribute('data-variant-id')) : '';
    }

    function formatMoney(cents) {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format((Number(cents) || 0) / 100);
    }

    function calcFallbackCompare(priceCents) {
      // Etsy-Vergleichspreis-Formel: ceil(price * 1.35) auf .90er Stelle
      // 25.00 € → 25*1.35=33.75 → ceil=34 → 33.90 €
      if (priceCents <= 0) return 0;
      const priceEur = priceCents / 100;
      const ceiled = Math.ceil(priceEur * 1.35);
      return (ceiled * 100) - 10;
    }

    function sync() {
      const variantId = selectedVariantId();
      const variantPricing = variantId ? variantsMap[variantId] : null;
      const price = variantPricing ? variantPricing.price : 0;
      let comparePrice = variantPricing ? variantPricing.compareAtPrice : 0;

      if (comparePrice <= price) {
        const metaFallback = Number(note.dataset.fallbackComparePrice) || 0;
        if (metaFallback > price) {
          comparePrice = metaFallback;
        } else {
          comparePrice = calcFallbackCompare(price);
        }
      }

      if (comparePrice > price && price > 0) {
        const percent = Math.floor(((comparePrice - price) * 100) / comparePrice);
        base.textContent = formatMoney(comparePrice);
        hint.textContent = percent + '% günstiger als auf Etsy';
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }

    document.addEventListener('change', function (event) {
      const target = event.target;
      if (!target) return;
      if (target.matches('input[name="id"], .variant-picker input[type="radio"], .variant-picker input[type="checkbox"]')) {
        sync();
      }
    });

    sync();
  }

  function initMobileSummaryBar() {
    const summaryBar = document.querySelector('.la-pdp-mobile-summary');
    if (!summaryBar || window.matchMedia('(min-width: 990px)').matches) return;
    summaryBar.classList.add('is-visible');
  }

  function initAddToCartAccessibility() {
    const selector = '.la-pdp-buy-box .add-to-cart-button, .la-pdp-mobile-summary .add-to-cart-button';

    function syncButton(button) {
      if (!button || button.dataset.laAtcBound === 'true') return;

      const primary = button.querySelector('.add-to-cart-text__content') || button.querySelector('.add-to-cart-text');
      const added = button.querySelector('.add-to-cart__added');
      const addedLabel = added && added.querySelector('.add-to-cart-text--added');
      if (!primary || !added || !addedLabel) return;

      const primaryLabel = (primary.textContent || '').replace(/\s+/g, ' ').trim();
      const successLabel = (addedLabel.textContent || '').replace(/\s+/g, ' ').trim() || 'Im Warenkorb';
      if (!primaryLabel) return;
      addedLabel.dataset.label = successLabel;

      function applyState() {
        const isAdded = button.getAttribute('data-added') === 'true';
        primary.setAttribute('aria-hidden', isAdded ? 'true' : 'false');
        added.setAttribute('aria-hidden', isAdded ? 'false' : 'true');
        addedLabel.textContent = isAdded ? successLabel : '';
        button.setAttribute('aria-label', isAdded ? successLabel : primaryLabel);
      }

      const observer = new MutationObserver(function (mutations) {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-added') {
            applyState();
            break;
          }
        }
      });

      observer.observe(button, { attributes: true, attributeFilter: ['data-added'] });
      button.dataset.laAtcBound = 'true';
      applyState();
    }

    document.querySelectorAll(selector).forEach(syncButton);

    const rootObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches(selector)) {
            syncButton(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll(selector).forEach(syncButton);
          }
        });
      });
    });

    rootObserver.observe(document.body, { childList: true, subtree: true });
  }

  function initLightbox() {
    const dataEl = document.querySelector('.la-pdp-gallery-data');
    const lightbox = document.querySelector('.la-pdp-lightbox');
    if (!dataEl || !lightbox) return;

    let images = [];
    try {
      images = JSON.parse(dataEl.textContent.trim());
    } catch (error) {
      images = [];
    }
    if (!images.length) return;

    const stageImage = lightbox.querySelector('.la-pdp-lightbox__image');
    const counter = lightbox.querySelector('.la-pdp-lightbox__current');
    const thumbs = Array.from(lightbox.querySelectorAll('.la-pdp-lightbox__thumb'));
    let currentIndex = 0;
    let lastTrigger = null;

    function focusableNodes() {
      return Array.from(lightbox.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])'))
        .filter(function (node) { return !node.hasAttribute('disabled'); });
    }

    function update(index) {
      currentIndex = (index + images.length) % images.length;
      const current = images[currentIndex];
      stageImage.src = current.src;
      stageImage.srcset = current.srcset || '';
      stageImage.alt = current.alt || '';
      if (counter) counter.textContent = String(currentIndex + 1);
      thumbs.forEach(function (thumb, thumbIndex) {
        const active = thumbIndex === currentIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function open(index, trigger) {
      update(index);
      lastTrigger = trigger || document.activeElement;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('la-pdp-lightbox-open');
      const closeButton = lightbox.querySelector('.la-pdp-lightbox__close');
      if (closeButton) closeButton.focus();
    }

    function close() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('la-pdp-lightbox-open');
      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
    }

    document.querySelectorAll('.la-pdp-gallery-grid__item[data-gallery-index]').forEach(function (button) {
      button.addEventListener('click', function () {
        open(parseInt(button.getAttribute('data-gallery-index') || '0', 10), button);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        update(parseInt(thumb.getAttribute('data-gallery-index') || '0', 10));
      });
    });

    const closeButton = lightbox.querySelector('.la-pdp-lightbox__close');
    const prevButton = lightbox.querySelector('.la-pdp-lightbox__nav--prev');
    const nextButton = lightbox.querySelector('.la-pdp-lightbox__nav--next');
    const backdrop = lightbox.querySelector('.la-pdp-lightbox__backdrop');

    closeButton && closeButton.addEventListener('click', close);
    backdrop && backdrop.addEventListener('click', close);
    prevButton && prevButton.addEventListener('click', function () { update(currentIndex - 1); });
    nextButton && nextButton.addEventListener('click', function () { update(currentIndex + 1); });

    lightbox.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') update(currentIndex - 1);
      if (event.key === 'ArrowRight') update(currentIndex + 1);
      if (event.key === 'Tab') {
        const nodes = focusableNodes();
        if (!nodes.length) return;
        const first = nodes[0];
        const last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  function initShopReviewsCarousel() {
    const area = document.querySelector('.la-pdps__carousel-area');
    if (!area || area.dataset.laShopFeedbackMounted === 'true') return;

    function readAllReviewsData() {
      if (
        window.jdgm &&
        window.jdgm.data &&
        window.jdgm.data.allReviewsWidgetV2025 &&
        Array.isArray(window.jdgm.data.allReviewsWidgetV2025.all_reviews)
      ) {
        return window.jdgm.data.allReviewsWidgetV2025;
      }

      const script = document.querySelector('.jdgm-all-reviews-widget-v2025-data');
      if (!script) return null;

      const match = (script.textContent || '').match(/allReviewsWidgetV2025\s*=\s*(\{[\s\S]*\});?/);
      if (!match) return null;

      try {
        return JSON.parse(match[1]);
      } catch (error) {
        return null;
      }
    }

    const allReviewsData = readAllReviewsData();
    const allReviews = allReviewsData && Array.isArray(allReviewsData.all_reviews)
      ? allReviewsData.all_reviews
      : [];

    const shopReviews = allReviews
      .filter(function (review) {
        return review && Number(review.rating) === 5 && (review.is_shop_review === true || review.product_title);
      })
      .sort(function (a, b) {
        return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
      })
      .slice(0, 10);

    if (!shopReviews.length) return;

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (char) {
        return ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        })[char];
      });
    }

    function reviewerInitials(name, fallback) {
      const parts = String(name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2);
      if (parts.length) {
        return parts.map(function (part) { return part.charAt(0).toUpperCase(); }).join('');
      }
      return String(fallback || 'K').slice(0, 2).toUpperCase();
    }

    function formatDate(value) {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return new Intl.DateTimeFormat('de-DE', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }).format(date);
    }

    area.dataset.laShopFeedbackMounted = 'true';
    area.classList.add('is-la-shop-feedback-ready');
    area.innerHTML = [
      '<section class="la-shop-feedback" aria-label="Aktuelle Kundenbewertungen">',
      '  <div class="la-shop-feedback__header">',
      '    <div class="la-shop-feedback__header-copy">',
      '      <p class="la-shop-feedback__eyebrow">Kundenfeedback</p>',
      '      <h3 class="la-shop-feedback__title">Aktuelle Kundenbewertungen</h3>',
      '      <p class="la-shop-feedback__subline">Echte Erfahrungen mit LaserArt Germany aus verifizierten Shop- und Produktbewertungen.</p>',
      '    </div>',
      '    <div class="la-shop-feedback__nav" aria-label="Carousel Navigation">',
      '      <button class="la-shop-feedback__button la-shop-feedback__button--prev" type="button" aria-label="Vorherige Bewertung">‹</button>',
      '      <button class="la-shop-feedback__button la-shop-feedback__button--next" type="button" aria-label="Nächste Bewertung">›</button>',
      '    </div>',
      '  </div>',
      '  <div class="la-shop-feedback__viewport">',
      '    <div class="la-shop-feedback__track" role="list"></div>',
      '  </div>',
      '  <div class="la-shop-feedback__footer">',
      '    <div class="la-shop-feedback__progress" aria-hidden="true"><span class="la-shop-feedback__progress-bar"></span></div>',
      '    <a class="la-shop-feedback__link" href="/pages/reviews">Alle Bewertungen ansehen</a>',
      '  </div>',
      '</section>'
    ].join('');

    const track = area.querySelector('.la-shop-feedback__track');
    const prevButton = area.querySelector('.la-shop-feedback__button--prev');
    const nextButton = area.querySelector('.la-shop-feedback__button--next');
    const progressBar = area.querySelector('.la-shop-feedback__progress-bar');
    const summaryPanel = document.querySelector('.la-pdps__panel');

    track.innerHTML = shopReviews.map(function (review, index) {
      const name = escapeHtml(review.reviewer_name || 'Kunde');
      const body = escapeHtml(review.body || '');
      const initials = escapeHtml(reviewerInitials(review.reviewer_name, review.reviewer_initial));
      const date = escapeHtml(formatDate(review.created_at));
      const reviewType = review.is_shop_review === true ? 'Shop-Bewertung' : 'Produktbewertung';
      const badges = [];
      if (review.verified_buyer) badges.push('<span class="la-shop-feedback__badge">Verifiziert</span>');
      badges.push('<span class="la-shop-feedback__badge">Judge.me</span>');

      return [
        '<article class="la-shop-feedback__card" role="listitem" data-review-index="', String(index), '">',
        '  <div class="la-shop-feedback__card-top">',
        '    <div class="la-shop-feedback__avatar" aria-hidden="true">', initials, '</div>',
        '    <div class="la-shop-feedback__meta">',
        '      <strong>', name, '</strong>',
        '      <span>', date, '</span>',
        '    </div>',
        '    <div class="la-shop-feedback__stars" aria-label="5 von 5 Sternen">★★★★★</div>',
        '  </div>',
        '  <div class="la-shop-feedback__body"><p>', body, '</p></div>',
        '  <div class="la-shop-feedback__bottom">',
        '    <div class="la-shop-feedback__badges">', badges.join(''), '</div>',
        '    <span class="la-shop-feedback__tag">', escapeHtml(reviewType), '</span>',
        '  </div>',
        '</article>'
      ].join('');
    }).join('');

    const cards = Array.from(track.querySelectorAll('.la-shop-feedback__card'));
    if (!cards.length) return;

    let activeIndex = 0;

    function cardGap() {
      const styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap || '0') || 0;
    }

    function syncProgress(index) {
      activeIndex = Math.max(0, Math.min(index, cards.length - 1));
      const ratio = cards.length <= 1 ? 1 : (activeIndex + 1) / cards.length;
      progressBar.style.transform = 'scaleX(' + ratio + ')';
      prevButton.disabled = activeIndex <= 0;
      nextButton.disabled = activeIndex >= cards.length - 1;
    }

    function scrollToCard(index) {
      const safeIndex = Math.max(0, Math.min(index, cards.length - 1));
      const card = cards[safeIndex];
      if (!card) return;
      const offset = Math.max(0, card.offsetLeft - cardGap() * 0.35);
      track.scrollTo({ left: offset, behavior: 'smooth' });
      syncProgress(safeIndex);
    }

    function syncSummaryPanelHeight() {
      if (!summaryPanel || !window.matchMedia('(min-width: 961px)').matches) {
        if (summaryPanel) {
          summaryPanel.style.minHeight = '';
        }
        return;
      }

      summaryPanel.style.minHeight = area.offsetHeight + 'px';
    }

    prevButton.addEventListener('click', function () {
      scrollToCard(activeIndex - 1);
    });

    nextButton.addEventListener('click', function () {
      scrollToCard(activeIndex + 1);
    });

    const observer = new IntersectionObserver(function (entries) {
      let bestEntry = null;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (!bestEntry || entry.intersectionRatio > bestEntry.intersectionRatio) {
          bestEntry = entry;
        }
      });
      if (!bestEntry) return;
      const index = parseInt(bestEntry.target.getAttribute('data-review-index') || '0', 10);
      syncProgress(index);
    }, {
      root: area.querySelector('.la-shop-feedback__viewport'),
      threshold: [0.35, 0.6, 0.9]
    });

    cards.forEach(function (card) {
      observer.observe(card);
    });

    syncProgress(0);
    syncSummaryPanelHeight();
    window.addEventListener('resize', syncSummaryPanelHeight);
  }

  function initGloboTotalMirror() {
    // Globo Product Options berechnet Personalisierungs-Aufpreise selbst und
    // zeigt sie in .gpo-total .gpo-total-text .money — wird hier nur
    // gespiegelt (nicht neu berechnet), siehe Konfigurator-Architektur-
    // Entscheidung 12.08.2026 (Globo-Feldstruktur ist nicht theme-seitig
    // vorhersagbar, daher keine eigene Aufpreis-Rechnung im Theme).
    const globoRoot = document.querySelector('.gpo-app');
    const mirrorTarget = document.querySelector('.la-pdp-mobile-summary__price, sticky-add-to-cart [ref="quantityDisplay"]');
    if (!globoRoot || !mirrorTarget) return;

    function readGloboTotal() {
      const moneyEl = globoRoot.querySelector('.gpo-total .gpo-total-text .money, .gpo-total .money');
      return moneyEl ? moneyEl.textContent.trim() : '';
    }

    const summaryPrice = document.querySelector('.la-pdp-mobile-summary__price');

    function sync() {
      const total = readGloboTotal();
      if (total && summaryPrice) {
        summaryPrice.textContent = total;
        summaryPrice.dataset.globoMirrored = 'true';
      }
    }

    const observer = new MutationObserver(sync);
    observer.observe(globoRoot, { childList: true, subtree: true, characterData: true });
    sync();
  }

  function initVariantScrollHints() {
    const fieldsets = document.querySelectorAll('.la-pdp-buy-box .variant-option--buttons');
    if (!fieldsets.length) return;

    const entries = [];

    fieldsets.forEach(function (fieldset) {
      if (fieldset.closest('.la-variant-scroll-wrap')) return;

      const wrap = document.createElement('div');
      wrap.className = 'la-variant-scroll-wrap';
      wrap.style.marginTop = getComputedStyle(fieldset).marginTop;
      fieldset.style.marginTop = '0';

      fieldset.parentNode.insertBefore(wrap, fieldset);
      wrap.appendChild(fieldset);

      const hint = document.createElement('div');
      hint.className = 'la-variant-scroll-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML = '<svg class="la-variant-scroll-hint__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
      wrap.appendChild(hint);

      entries.push({ fieldset: fieldset, hint: hint });
      fieldset.addEventListener('scroll', function () {
        updateHint(fieldset, hint);
      }, { passive: true });
    });

    function updateHint(fieldset, hint) {
      const hasOverflow = fieldset.scrollHeight > fieldset.clientHeight + 1;
      const atBottom = fieldset.scrollTop + fieldset.clientHeight >= fieldset.scrollHeight - 2;
      hint.classList.toggle('is-visible', hasOverflow && !atBottom);
    }

    function updateAll() {
      entries.forEach(function (entry) {
        updateHint(entry.fieldset, entry.hint);
      });
    }

    updateAll();
    window.addEventListener('resize', updateAll);
    window.addEventListener('load', updateAll);
  }

  function init() {
    initConfigurationTriggers();
    initDeliveryCard();
    initCompareNote();
    initMobileSummaryBar();
    initAddToCartAccessibility();
    initLightbox();
    initShopReviewsCarousel();
    initGloboTotalMirror();
    initVariantScrollHints();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
